<template>
  <div class="content">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'AuthLayout',
};
</script>
